import React from 'react'
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import SearchAutosuggestComponent from './SearchAutosuggestComponent'
import AutosuggestComponent from './AutosuggestComponent'
import { DebounceInput } from 'react-debounce-input';
import DatePicker from "@sentisso/react-modern-calendar-datepicker";
import '@sentisso/react-modern-calendar-datepicker/lib/DatePicker.css';
import OrgFilter from './OrgFilter';
import CustomButton from './CustomButton';

function FilterContentSection(props) {
    const { handleChangeOrganizationFilter, organizationFilterSelectedData, handleChangeUserFilter, userTypeList, user_type_filter, travailleursModalfunction, handleUserSearchBar, userName, clearSearchValue, totalDatasetCount, userCredentials } = props;
    let version = userCredentials?.user_details?.version
    let roleName = userCredentials?.user_details?.user_type

    return (
        <>
            {/* {version != "v1" ?
                <>
                    <SearchAutosuggestComponent
                            handleChangeOrganizationFilter={handleChangeOrganizationFilter}
                            organizationFilterSelectedData={organizationFilterSelectedData}
                        />
                    <div className="dropdownbox enterprisedrop">
                        <AutosuggestComponent
                            handleOnChange={(e) => { handleChangeUserFilter('user_type_filter', e) }}
                            options={userTypeList}
                            selectedValue={user_type_filter}
                            name=''
                            isMulti={false}
                            placeholder="User type"
                            isDisabled={false}
                            isClearable={true}
                            closeButton={true}
                            menuHeader="User type"
                            isSearchable={true}
                        />
                    </div>
                </>
                : ""} */}
            <div className="pageinnersearch">
                <button type="button" className="btn btn-link search_btn_addon"><i className="fa fa-search"></i></button>
                <DebounceInput
                    minLength={2}
                    debounceTimeout={500}
                    onChange={(e) => handleUserSearchBar(e)}
                    placeholder="Search by username"
                    value={userName}
                />
                {
                    userName != "" ?
                        < button type="button" className="btn btn-link dropclosebtn" onClick={clearSearchValue}>
                            <img src={require('../../Utility/Public/images/dropcloseicon.png')} className="searchClearIcon" />
                        </button>
                        : null}
            </div>
        </>
    )
}
const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials
    };
}

export default withRouter(connect(mapStateToProps, {})
    (withTranslation()(FilterContentSection)));
